/** Display helpers for wallet TRANSFER rows enriched by the API. */

export function isTransferTxn(row) {
  return String(row?.type ?? "").toUpperCase() === "TRANSFER";
}

export function hasTransferDetails(row) {
  if (!isTransferTxn(row)) return false;
  return Boolean(row?.transfer_shares || row?.transfer_share_price_bdt || row?.transfer_at);
}

export function formatTransferAt(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return String(iso);
  }
}

/** @returns {{ label: string, value: string }[]} */
export function transferDetailLines(row) {
  if (!hasTransferDetails(row) && !row?.transfer_project_name) return [];
  const lines = [];
  if (row.transfer_project_name) {
    lines.push({ label: "Project", value: row.transfer_project_name });
  }
  if (row.transfer_shares) {
    lines.push({ label: "Shares", value: `${row.transfer_shares} sh` });
  }
  if (row.transfer_share_price_bdt) {
    lines.push({ label: "Share price", value: `BDT ${row.transfer_share_price_bdt}/sh` });
  }
  if (row.transfer_at) {
    lines.push({ label: "Transfer time", value: formatTransferAt(row.transfer_at) });
  }
  return lines;
}
